import { render } from "./SettleBets.vue?vue&type=template&id=3a29cd40"
import script from "./SettleBets.vue?vue&type=script&lang=js"
export * from "./SettleBets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__